import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchTracingMetrics } from '@/api/report';
import { useSessionStore } from '@/store/sessionStore';

export function tracingOperationsQueryOptions(
  companyId: string,
  filter: string,
) {
  return queryOptions({
    queryKey: ['report', 'tracing-operations', companyId, filter] as const,
    queryFn: () =>
      fetchTracingMetrics(companyId, filter).then(({ data }) => data),
    enabled: !!companyId && !!filter,
  });
}

export function useTracingOperationsQuery(filter: string) {
  const companyId = useSessionStore(s => s.user?.companyId ?? '');
  return useQuery(tracingOperationsQueryOptions(companyId, filter));
}
